export default "__VITE_ASSET__36f3735c__"